import NotificationIcon from '@mui/icons-material/NotificationsActive';
import Tooltip from '@mui/material/Tooltip';

import useUser from '../../hooks/useUser';

const LeadHasUpdates = ({ lead }) => {
  const user = useUser();
  if (!user) return null;
  const providerId = user?.provider?.id;
  const hasAssigneeUpdates = !!lead?.has_updates && providerId === lead?.provider?.id;
  const hasSubscriberUpdates = (lead?.unseen_by_subscriber_ids || []).includes(providerId);
  if (!hasAssigneeUpdates && !hasSubscriberUpdates) return null;
  return (
    <Tooltip title={'Updated!'}>
      <NotificationIcon style={{fontSize: '1.1rem'}} color='secondary' />
    </Tooltip>
  );
};

export default LeadHasUpdates;